import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBuyerOverridesPartialPaymentAmount } from '../state/BuyerOverrides/selectors';
import BuyerOverridesActionTypes from '../state/BuyerOverrides/actionTypes';
export function getHighestMaxPaymentMethodLimit(acceptedPaymentMethods, maximumAmountForPaymentMethod) {
  if (!maximumAmountForPaymentMethod || acceptedPaymentMethods.length === 0) {
    return undefined;
  }
  const validLimits = acceptedPaymentMethods.filter(method => maximumAmountForPaymentMethod[method] !== undefined).map(method => maximumAmountForPaymentMethod[method]);
  return validLimits.length > 0 ? Math.max(...validLimits) : undefined;
}
export function useInitializePartialPaymentAmount({
  checkoutSession,
  limits,
  limitsLoading
}) {
  var _checkoutSession$get, _checkoutSession$get2;
  const dispatch = useDispatch();
  const partialPaymentAmount = useSelector(getBuyerOverridesPartialPaymentAmount);
  const partialPaymentsInfo = (_checkoutSession$get = checkoutSession.get('partialPaymentsInfo')) === null || _checkoutSession$get === void 0 ? void 0 : _checkoutSession$get.toJS();
  const paymentMethods = ((_checkoutSession$get2 = checkoutSession.get('paymentMethods')) === null || _checkoutSession$get2 === void 0 ? void 0 : _checkoutSession$get2.toJS()) || [];
  const acceptedPaymentMethods = paymentMethods.map(({
    paymentMethod
  }) => paymentMethod);
  const highestMaxLimit = useMemo(() => getHighestMaxPaymentMethodLimit(acceptedPaymentMethods, limits === null || limits === void 0 ? void 0 : limits.maximumAmountForPaymentMethod), [acceptedPaymentMethods, limits === null || limits === void 0 ? void 0 : limits.maximumAmountForPaymentMethod]);
  const balanceDue = partialPaymentsInfo !== null && partialPaymentsInfo !== void 0 && partialPaymentsInfo.isPartialPaymentsEnabled ? partialPaymentsInfo === null || partialPaymentsInfo === void 0 ? void 0 : partialPaymentsInfo.balanceDue : undefined;
  useEffect(() => {
    if (partialPaymentAmount === undefined && typeof balanceDue === 'number' && !limitsLoading) {
      const amountToSet = highestMaxLimit != null ? Math.min(balanceDue, highestMaxLimit) : balanceDue;
      dispatch({
        type: BuyerOverridesActionTypes.SET_PARTIAL_PAYMENT_AMOUNT,
        data: {
          partialPaymentAmount: amountToSet
        }
      });
    }
  }, [dispatch, partialPaymentAmount, balanceDue, limitsLoading, highestMaxLimit]);
}